import { Injectable, inject } from '@angular/core';
import { DevicesRouterStoreSelectors, NotesStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NoteResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (!udid) {
          return;
        }

        this.store.dispatch(NotesStoreActions.NotesResolverActions.notesRequested({ udid }));
      }),
      map(() => true),
      first()
    );
  }
}
